<template>
  <confirm
    name="albumPickerModal"
    v-show="isShow"
    @confirm="handleConfirm"
    :data="dialogData"
  >
    <div class="album-picker-modal row">
      <draggable
        :list="imageUrls"
        ghost-class="ghost"
        class="list-group first"
        @start="dragging = true"
        @end="dragging = false"
      >
        <div
          v-for="(imageUrl, index) in imageUrls"
          :key="imageUrl"
          class="position-relative ml-3 mt-3"
        >
          <div class="image">
            <span
              class="position-absolute album-remove pointer"
              @click="removeImage(index)"
              >&times;</span
            >
            <a :href="imageUrl" target="_blank">
              <img :src="imageUrl" alt="" class="photo" />
            </a>
          </div>
        </div>
      </draggable>
      <div>
        <div v-if="dimension" class="upload-box ml-3 mt-3" @click="openImageSelector">
          <img :src="'/static/icons/button-add-cover.svg'" />
        </div>
        <div v-else class="upload-box ml-3 mt-3">
          <image-upload-and-resize
            v-bind="chooseImageFullDimensionDialog"
            @confirm="addImageAlbum"
          ></image-upload-and-resize>
        </div>
      </div>
    </div>
    <div class="remake">ขนาดไฟล์สูงสุดคือ 1 MB</div>
    <image-picker-modal
      v-bind="chooseImageDialog"
      @cancel="handleCancelChooseImage"
      @confirm="addImageAlbum"
    ></image-picker-modal>
  </confirm>
</template>

<script>
import { isEmpty, isNil } from "ramda";
import { UPLOAD } from "@/config/constant";
import draggable from "vuedraggable";
import { uploadPublicImage, uploadImageAndGetUrlAndKey } from "@/god";
import ImagePickerModal from "@/lib/components/ImagePickerModal";
import ImageUploadAndResize from "@/lib/components/ImageUploadAndResize";


export default {
  props:
    // PROPS PARAMS
    // title {string}: "Package Album",
    // canEdit {boolean}: true,
    // isShow {boolean}: true,
    // album {array}: [
      // https://storage.googleapis.com/sca-prod-brj-article-upload/article/article-1589948015964-d99466b6-e9e7-4b7f-ae41-99bb81dc5969,
      // https://storage.googleapis.com/sca-prod-brj-article-upload/article/article-1580974464006-369a75bd-bd7c-4b69-a5f3-878923584831
    // ]
    // imageName {string}: "รูปถังน่้ำ",
    // remark {object / undefined}: {
    //   firstRemark {string}: "สามารถเลื่อนตำแหน่งการแสดงผลได้",
    //   secondRemark {string}: "รูปแรกจะเป็นรูปหลักของ package เสมอ"
    // },
    // dimension {object / undefined}: {
    //   width {number}: 300,
    //   height {number}: 200,
    //   recommendWidth {number}: 1200,
    //   recommendHeight {number}: 800
    // },
    // titleForChooseImage {string}: "กรุณาเลือกรูป"
    // pathImage {string}: "withholding_tax"
    // isNotMakePublicImage {boolean}: false
  [
    "title",
    "canEdit",
    "isShow",
    "album",
    "imageName",
    "remark",
    "dimension",
    "titleForChooseImage",
    "pathImage",
    "isNotMakePublicImage"
  ],
  components: {
    draggable,
    ImagePickerModal,
    ImageUploadAndResize
  },
  watch: {
    album() {
      this.imageUrls = !(isNil(this.album) || isEmpty(this.album))
        ? this.album
        : [];
    },
  },
  data() {
    return {
      imageUrls: [],
      upload: UPLOAD,
      isShowImageModal: false
    };
  },
  computed: {
    dialogData() {
      const buttonSubmit = "บันทึก";

      return {
        title: this.title,
        buttonCancel: "ยกเลิก",
        buttonSubmit,
        disableSubmit: false,
        disableCancel: false,
        hideAction: false,
        remark: this.remark && this.remark.firstRemark,
        secondRemark: this.remark && this.remark.secondRemark
      };
    },
    chooseImageDialog() {
      return {
        isShow: this.isShowImageModal && this.dimension,
        isLoading: false,
        canEdit: true,
        title: this.titleForChooseImage || "เลือกรูป",
        width: this.dimension && this.dimension.width || 300,
        height: this.dimension && this.dimension.height || 200,
        recommendWidth: this.dimension && this.dimension.recommendWidth || 1200,
        recommendHeight: this.dimension && this.dimension.recommendHeight || 800,
        thumbnailFile: null,
        thumbnailUrl: null
      };
    },
    chooseImageFullDimensionDialog() {
      return {
        isPreviewImage: false
      };
    }
  },
  methods: {
    async addImageAlbum(file) {
      if (isNil(file)) {
        return;
      }

      if (file.size / 1024 / 1024 > UPLOAD.MAX_FILE_SIZE_MB) {
        alert("รูปขนาดเกิน 1 MB ไม่สามารถอัพโหลดได้");
        return;
      }

      let imageUrl
      if (this.isNotMakePublicImage) {
        // NOTE: use function getKeyByUrlPath to get key image
        const imageToNeedAccessToken = await uploadImageAndGetUrlAndKey(
          file,
          this.imageName,
          this.pathImage
        )

        imageUrl = imageToNeedAccessToken
      } else {
        const imagePublic = await uploadPublicImage(
          file,
          this.imageName,
          this.pathImage
        );

        imageUrl = imagePublic
      }

      this.imageUrls.push(imageUrl);

      this.isShowImageModal = false;
    },
    removeImage(imagePosition) {
      this.imageUrls = this.imageUrls.filter(
        (url, index) => index != imagePosition
      );
    },
    openImageSelector() {
      this.isShowImageModal = true
    },
    handleConfirm(isConfirm) {
      if (!isConfirm) {
        const imageUrls = !(isNil(this.album) || isEmpty(this.album))
          ? this.album
          : [];

        this.imageUrls = imageUrls;

        this.$emit("cancel");
        return;
      }

      const mainImage = this.imageUrls && this.imageUrls.length > 0
          ? this.imageUrls[0]
          : undefined;

      if (this.imageUrls && this.imageUrls.length > 1) {
        this.imageUrls.shift();
      } else {
        this.imageUrls = [];
      }

      const allImageToAlbum =
        !(isNil(this.imageUrls) || isEmpty(this.imageUrls)) && mainImage
          ? [mainImage].concat(this.imageUrls)
          : mainImage
          ? [mainImage]
          : [];

      this.imageUrls = allImageToAlbum;

      this.$emit("confirm", {
        packageAlbums: this.imageUrls,
        allImageToAlbum,
        imageFile: mainImage,
      });
    },
    handleCancelChooseImage() {
      this.isShowImageModal = false
    }
  }
};
</script>

<style lang="scss">
.album-picker-modal {
  border: 2px dashed #d8d6d9;
  line-height: 1.21;
  letter-spacing: normal;
  color: #8c8786;

  margin: 0 auto;
  overflow: auto;
  width: 550px;
  height: 400px;
}

.photo {
  width: 148px;
  height: 148px;
  border-radius: 16px;
  border: hidden;
  object-fit: cover;

  &.added {
    border: 1px solid #e0e0e0;
  }
}

.upload-box {
  width: 148px;
  height: 148px;
  border-radius: 16px;
  border: 2px dashed #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.setting-body {
  padding: 20px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.album-remove {
  top: 5px;
  right: 5px;
  background: #aaa;
  border-radius: 50%;
  border: 2px solid $white;
  width: 20px;
  height: 20px;
  padding: 3px;

  font-size: 16px;
  color: $white;
  line-height: 0.5;
}

.remake {
  font-size: 11px;
  font-weight: normal;
  line-height: 1.64;
  letter-spacing: -0.1px;
  color: #8c8786;
  margin-top: 16px;
  text-align: center;
}

.input-file {
  opacity: 0;
  position: absolute;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.first {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  justify-items: center;
  text-align: center;
}

.list-group-item {
  width: 100% !important;
}

.image {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/lib/components/AlbumAndSwipePicker.vue